import { cn } from '@/ui/utils'
import { A } from '@expo/html-elements'
import { Link } from 'expo-router'
import { linkWebStyles } from './link.styles'
import type { ExternalRouteProps, RouterLinkProps } from './link.types'

const RouterLink = ({ className, href, children, ...props }: RouterLinkProps) => {
	return (
		<Link className={cn(linkWebStyles(), className)} href={href} {...props}>
			{children}
		</Link>
	)
}

const ExternalLink = ({ className, href, children, ...props }: ExternalRouteProps) => {
	return (
		<A className={cn(linkWebStyles(), className)} href={href} target="_blank" {...props}>
			{children}
		</A>
	)
}

export { RouterLink, ExternalLink }
